import { graphql } from "gql";

const COUNT_QUERY = graphql(`
  query count($searchFilterList: [SearchFilter!]!) {
    count(searchFilterList: $searchFilterList)
  }
`);

export default COUNT_QUERY;
